<div id="scholarship" class="inner-page py-5 bg-light">
  <div class="container px-lg-5">

    <div class="text-center mb-5">
      <h1 class="display-6 fw-bold text-uppercase text-dark mb-2">Scholarships</h1>
      <p class="lead text-muted">View or download details and eligibility guidelines for all available college scholarships.</p>
      <hr class="divider mx-auto" style="width: 80px; height: 3px; background: var(--primary); border: none; opacity: 1;">
    </div>

    <!-- Download and Action Button -->
    <div class="row justify-content-center mb-4">
      <div class="col-md-6 col-lg-4">
        <a href="/assets/pdf/student-facilities/Links-for-Scholarships.pdf" target="_blank"
          class="pdf-download-btn w-100 text-center py-2 px-3 d-inline-block rounded-3 text-white fw-semibold"
          style="background: var(--primary); text-decoration: none; transition: background 0.3s ease;">
          <i class="fa fa-file-pdf-o me-2"></i>Download Scholarship PDF
        </a>
      </div>
    </div>

    <!-- Embedded Premium PDF Viewer Card -->
    <div class="card shadow rounded-4 border-0 overflow-hidden mb-5">
      <div class="card-header bg-success text-white py-3 px-4 d-flex align-items-center justify-content-between">
        <h6 class="mb-0 fw-bold text-uppercase" style="letter-spacing: 0.5px;">Interactive Document Viewer</h6>
        <span class="badge bg-white text-success fw-bold px-2 py-1">PDF Mode</span>
      </div>
      <div class="card-body p-0" style="background: #eaeaea; min-height: 800px;">
        <pdf-viewer [src]="pdfSrc" [render-text]="true" [original-size]="false"
          style="width: 100%; height: 800px; position: relative;" class="rounded-bottom">
        </pdf-viewer>
      </div>
    </div>

  </div>
</div>